import { BacklogNotice } from "./BacklogNotice";
import { ContactGateStep } from "./ContactGateStep";
import { ReviewSummary } from "./ReviewSummary";
import { StepFields } from "./StepFields";
import { WizardShell } from "./WizardShell";
import { WizardSidebar } from "./WizardSidebar";
import { SERVICE_BY_KEY } from "./schemas";

/** Whichever of the three step kinds is on screen right now. */
const StepBody = ({ flow }) => {
  const { step } = flow;
  if (step.kind === "questions") {
    return (
      <StepFields
        step={step}
        answers={flow.answers}
        errors={flow.errors}
        focusPath={flow.focusPath}
        registerRef={flow.registerRef}
        onChange={flow.changeAnswer}
      />
    );
  }
  if (step.kind === "review") {
    return <ReviewSummary groups={flow.reviewGroups} onEdit={flow.editAnswer} />;
  }
  if (step.kind === "contact") {
    return (
      <ContactGateStep
        busy={flow.busy}
        serverErrors={flow.gateErrors}
        onSubmit={flow.submitGate}
      />
    );
  }
  return null;
};

/** The question wizard: progress, the current step, and the helper sidebar. */
export const PricingWizard = ({ flow }) => {
  const activeService = flow.service ? SERVICE_BY_KEY[flow.service] : null;

  return (
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
      <div className="lg:col-span-8">
        {activeService ? (
          <p className="mb-4 text-xs font-bold uppercase tracking-[0.14em] text-muted-foreground">
            {activeService.title}
          </p>
        ) : null}

        <WizardShell
          stepIndex={flow.stepIndex}
          totalSteps={flow.steps.length}
          step={flow.step}
          onBack={flow.goBack}
          onNext={flow.goNext}
          nextLabel={flow.nextLabel}
          busy={flow.busy}
          hideNext={flow.step.kind === "contact"}
        >
          <StepBody flow={flow} />
        </WizardShell>

        {flow.service === "bookkeeping" ? <BacklogNotice /> : null}
      </div>

      <WizardSidebar sessionId={flow.sessionId} onContactDirectly={flow.openGeneralFallback} />
    </div>
  );
};
